import React, { FormEvent } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { Button } from "../../../components/common";

interface BlogHeroProps {
  search: string;
  onSearchChange: (value: string) => void;
}

const BlogHero = ({ search, onSearchChange }: BlogHeroProps) => {

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
  };

  return (
    <section className="blog-hero">
      <div className="blog-hero__copy">
        <span className="blog-eyebrow">The employHER Blog</span>
        <h1>Real advice for every step of work</h1>
        <p>
          Career advice, job search guidance, workplace insights and inclusive
          hiring ideas from employHER.
        </p>
        <form className="blog-search" onSubmit={handleSubmit}>
          <SearchIcon aria-hidden="true" />
          <input
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search articles, topics or keywords"
            aria-label="Search blog articles"
          />
          <Button type="submit" className="blog-search__button">
            Search
          </Button>
        </form>
      </div>
      <div className="blog-hero__visual" aria-hidden="true">
        <img
          src="https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&w=1000&q=85"
          alt=""
        />
        <span className="blog-hero__shape blog-hero__shape--pink" />
        <span className="blog-hero__shape blog-hero__shape--purple" />
      </div>
    </section>
  );
};

export default BlogHero;
